export const XRewardConfig = {
  /** Bonus score awarded for sharing on X */
  shareBonus: 50,
  /** Whether sharing reward has been claimed this session */
  maxSharesPerSession: 1,
  /** Hashtags for the X share */
  hashtags: ["だるま落とし", "SwipeDaruma"],
  /** Base share text template. {score} will be replaced with actual score */
  shareTextTemplate: "だるま落としで {score} 点を獲得しました！🎯",
} as const;
